import React, { useContext } from 'react';
import * as PropTypes from 'prop-types';
import styles from './styles.modules.scss';
import { DataContext } from 'contexts';

const maxWidthMobile = 100;
const maxWidthDesktop = 36;

const FirmGraph = ({graphWidth, trucksWidth}) => {
    const {isMobile} =  useContext(DataContext);
    const maxWidth = isMobile ? maxWidthMobile : maxWidthDesktop;
    const totalWidth = graphWidth * maxWidth / 100;

    return (
        <div
            className={styles['graph']}
            style={{ width: `${totalWidth}%`, maxWidth: `${maxWidth}%` }}
        >
            <div
                className={styles['trucks']}
                style={{ width: `${trucksWidth}%` }}
            />
            <div
                className={styles['searches']}
                style={{ width: `${100 - trucksWidth}%` }}
            />
        </div>
    );
};

export default FirmGraph;

FirmGraph.propTypes = {
    graphWidth: PropTypes.number,
    trucksWidth: PropTypes.number
};
